import type { ICustomer } from "src/core/customers/api/customers.api";

import * as AT from "./customers.constants";

export type CustomerActions = IPurgeCustomers | ISetCustomer;

interface IPurgeCustomers {
  type: AT.PURGE_CUSTOMERS;
}

export const purgeCustomers = (): IPurgeCustomers => {
  return { type: AT.PURGE_CUSTOMERS };
};

interface ISetCustomer {
  type: AT.SET_CUSTOMER;
  customer: ICustomer | null;
}

export const setCustomer = (customer: ICustomer | null): ISetCustomer => {
  return {
    type: AT.SET_CUSTOMER,
    customer
  };
};
